<span [ngClass]="{ 'name': highlightName }"
      data-automation-e2e-selector="title">
    {{market.displayName}}:
</span>
<br *ngIf="highlightName"/>
<span class="price"
      data-automation-e2e-selector="price">
    {{market.price | number : '1.2-2'}}
    <span [ngClass]="{ 'positive': market.change > 0, 'negative': market.change < 0 }">
        <span *ngIf="showChange"
              data-automation-e2e-selector="delta">
            {{market.change | iexChange}} ({{(delta) | percent: '1.2-2'}})
        </span>
        <span *ngIf="!showChange"
              data-automation-e2e-selector="delta">
            ({{(delta) | percent: '1.2-2'}})
        </span>
    </span>
</span>